import React from 'react';
import Header from '../components/header.component';
import { Footer } from '../components/footer.component';
import FeaturesComponent from '../components/features.component';
import SEOMetadataComponent from '../components/seo-metadata.component';
import { LOCALES } from '../../common/constants';
import { useTranslation } from 'react-i18next';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SectionHeader from '../components/common';

const FeaturesPage: React.FC = () => {
    const { t, i18n } = useTranslation();

    const currentLanguage = i18n.language;

    const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;

    const canonicalUrl = isEnglish
        ? `https://www.invozio.com/function?lang=${LOCALES.EN_US}`
        : `https://www.invozio.com/funktion?lang=${LOCALES.SV_SE}`;


    const schemaMarkup = getSchemaMarkup("funktion");

    return (
        <>
            <Header />
            <SEOMetadataComponent
                title={t('FEATURES_MAIN_TITLE')}
                description={t('FEATURES_MAIN_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
             <SectionHeader
                titleKey={t('FEATURES_PAGE_TITLE')}
                subtitleKey={t('FEATURES_PAGE_DESCRIPTION')}
                className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            />
            <FeaturesComponent />
            <div className="bg-footer">
                <Footer />
            </div>
        </>
    );
};

export default FeaturesPage;
